import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, FormGroup, Label, Col, Input } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import { systemAdditionalChargesList } from '../../../../../utils/Constants';
class AdditionalChargeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentAdditionalCharge: {
                id: -1,
                type: null,
                name: '',
                week: null,
                year: null,
                amount: null,
                createdDate: null,
                description: '',
                createDate: null,
                period: null
            },
            addition: 'Addition',
            deduction: 'Deduction',
        };
    }

    componentDidMount() {

        if(this.props.currentAdditionalCharge.name) {
            this.setState({
                ...this.state,
                currentAdditionalCharge: this.props.currentAdditionalCharge
            })
        } else {
            this.setState({
                ...this.state,
                currentAdditionalCharge: {
                    ...this.state.currentAdditionalCharge,
                    type: this.state.addition
                }
            })
        }
    }

    changeState = ({ target }) => {

        this.setState({
            currentAdditionalCharge: {
                ...this.state.currentAdditionalCharge,
                [target.name]: target.value 
            },
            [target.name]: target.value,
        });
    }

    submitForm(restaurantId) {

        const additionalCharge = this.state.currentAdditionalCharge;
        
        if(additionalCharge.id !== -1) {
            this.props.editAdditionalCharge(additionalCharge, restaurantId)
        } else {
            this.props.applyCurrentAdditionalCharge(additionalCharge, restaurantId);
        }
       
    }

    validateIntegerField(e) {
        let inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 45 || inputKeyCode == 46 || inputKeyCode == 43
                || inputKeyCode == 69 || inputKeyCode == 101) {
                e.preventDefault();
            }
        }
    }

    checkIsSystemAdditionalCharge(additionalChargeType) {
        let isSystemAdditionalCharge = false;
        for(let i = 0; i< systemAdditionalChargesList.length; i++) {
            if(additionalChargeType.includes(systemAdditionalChargesList[i])) {
                isSystemAdditionalCharge = true;
            } 
        }
        return isSystemAdditionalCharge;
    }
    renderName() {
        const { name } = this.state.currentAdditionalCharge;

        return (
            <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={6}>{i18n.t('screens:paymentScreen.name')}</Label>
                <Col xs={6} style={{display: 'flex', flexDirection: 'column'}}>
                    <AvInput 
                        type="text" 
                        name="name"
                        placeholder={name}
                        value={name}
                        onChange={this.changeState}
                        required={true}
                        maxlength='128'
                        disabled={this.checkIsSystemAdditionalCharge(name)}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </Col>
            </AvGroup>
        )
    }

    renderDescription() {
        const { description } = this.state.currentAdditionalCharge;

        return (
            <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={6}>{i18n.t('screens:paymentScreen.description')}</Label>
                <Col xs={6} style={{display: 'flex'}}>
                    <AvInput 
                        type="text" 
                        name="description"
                        placeholder={description}
                        value={description}
                        onChange={this.changeState}
                        maxlength='255'
                    />
                </Col>
            </AvGroup>
        )
    }

    renderType() {
        const { type, name } = this.state.currentAdditionalCharge;
        const { addition, deduction } = this.state;

        return (
            <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={6}>{i18n.t('screens:paymentScreen.type')}</Label>
                <Col xs={6} style={{display: 'flex'}}>
                    <AvInput 
                        type="select" 
                        name="type"
                        value={type} 
                        onChange={this.changeState}
                        disabled={this.checkIsSystemAdditionalCharge(name)}>
                        <option id={1} value={addition}>{i18n.t('screens:paymentScreen.addition')}</option>
                        <option id={2} value={deduction}>{i18n.t('screens:paymentScreen.deduction')}</option>
                    </AvInput>
                </Col>
            </AvGroup>
        )
    }

    renderWeekYear() {
        const { week, year, name } = this.state.currentAdditionalCharge;

        return (
            <div style={{ display: 'flex'}}>
                <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                    <Label xs={6}>{i18n.t('screens:paymentScreen.week')}</Label>
                    <Col xs={6} style={{display: 'flex', flexDirection: 'column'}}>
                        <AvInput 
                            type="number" 
                            name="week"
                            value={week}
                            onChange={this.changeState}
                            required
                            onKeyPress={(e) => this.validateIntegerField(e)}
                            maxlength='2'
                            disabled={this.checkIsSystemAdditionalCharge(name)}
                        />
                        <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                    </Col>
                </AvGroup>
                <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                    <Label xs={6}>{i18n.t('screens:paymentScreen.year')}</Label>
                    <Col xs={6} style={{display: 'flex', flexDirection: 'column'}}>
                        <AvInput 
                            type="number" 
                            name="year"
                            value={year}
                            onChange={this.changeState}
                            required
                            onKeyPress={(e) => this.validateIntegerField(e)}
                            maxlength='2'
                            disabled={this.checkIsSystemAdditionalCharge(name)}
                        />
                        <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                    </Col>
                </AvGroup>
            </div>
        )
    }

    renderTotalPrice() {
        const { amount, name } = this.state.currentAdditionalCharge;

        return (
            <AvGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px' }}>
                <Label xs={6}>{i18n.t('screens:paymentScreen.totalPrice')}</Label>
                <Col xs={6} style={{display: 'flex', flexDirection: 'column'}}>
                    <AvInput 
                        type="number" 
                        name="amount"
                        placeholder={amount}
                        value={amount}
                        onChange={this.changeState}
                        required
                        onKeyPress={(e) => this.props.negativeDecimalsValidation(e)}
                        disabled={this.checkIsSystemAdditionalCharge(name)}
                    />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </Col>
            </AvGroup>
        )
    }

    renderModalBody() {

        return (
            <Row>
                {this.renderName()}
                {this.renderDescription()}
                {this.renderType()}
                {this.renderWeekYear()}
                {this.renderTotalPrice()}
                {/* {
                    createdDate ?
                    <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '15px', alignItems: 'center'}}>
                        <Label xs={6}>{i18n.t('screens:paymentScreen.createDate')}</Label>
                        <Col xs={6} style={{display: 'flex'}}>
                            <Input 
                                type="text" 
                                name="createDate"
                                placeholder={'07.04.2022'}
                                value={'07.04.2022'}
                                disabled
                            />
                        </Col>
                    </FormGroup> : null
                } */}
            </Row>
        )
    }

    render() {
        const { id } = this.state.currentAdditionalCharge;
        const restaurantId = this.props.restaurant.id;
        
        return (
            <Modal className='additionalChargeModal' isOpen={this.props.isOpen} toggle={() => this.props.toggle(true)}>
                <AvForm onValidSubmit={() => this.submitForm(restaurantId)}>
                    <ModalHeader className="modalHeader" toggle={() => this.props.toggle(true)} style={{ margin: 'auto' }}>
                        {i18n.t('screens:paymentScreen.additionalCharge')}
                    </ModalHeader>
                    <ModalBody>
                        {this.renderModalBody()}
                    </ModalBody>
                    <ModalFooter>
                        {
                            this.props.additionalChargeIndex !== -1 ?
                                <Button
                                    color="primary" outline style={{ display: 'flex', alignItems: 'center' }}
                                    onClick={() => this.props.deleteCurrentAdditionalCharge(id, restaurantId)}>
                                    <span style={{ marginBottom: 1 }}>
                                        <MaterialIcon icon="delete" color="#0288D1" size={18} />
                                    </span>
                                    {i18n.t('common:buttons.delete')}
                                </Button> : null
                        }
                        <Button color="primary">
                            <MaterialIcon icon="check" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.save')}
                        </Button>
                    </ModalFooter>
                </AvForm>
            </Modal>
        );
    }
}

export default AdditionalChargeModal;


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/AdditionalChargeModal.js